import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import "./Tabs.css";
import { Dashboard } from "../Dashboard/DashBoard";
import { Detail } from "../Detail/Detail";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation,
  useParams,
  generatePath
} from "react-router-dom";
import { Button } from "@mui/material";
import { IOSSwitch } from "../../Gen/Switch";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

export const TabsMenu = () => {
  const { slug } = useParams();
  const path = useLocation().pathname;
  const [value, setValue] = React.useState();
  const pathname = path.split('/')[3];
  const detailRef = useRef();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(path);
  }, [path]);

  useEffect(() => {
    localStorage.setItem("SaveButton", detailRef);
  }, [detailRef]);
  return (
    <Box className="TabsContainer" sx={{ width: '100%' }}>
      <Box >
        <Tabs sx={{
          "& .MuiTab-root.Mui-selected": {
            color: '#EC492F'
          },
          "& .MuiButtonBase-root": {
            padding: "12px 0px"
          },
          "& .MuiButtonBase-root": {
            fontSize: "14px",
            fontWeight: "400",
            fontFamily: "Circe",
            textTransform: "capitalize",

          },
          minHeight: "30px"

        }} TabIndicatorProps={{
          style: {
            backgroundColor: "#EC492F"
          }
        }} value={value} onChange={handleChange} aria-label="basic tabs example" >
          <Tab className="TabSize" label="Dashboard" value={`/Channel/${slug}`} to={`/Channel/${slug}`} component={Link} />
          <Tab className="TabSize" label="Detail" value={`/Channel/${slug}/Detail`} to={`/Channel/${slug}/Detail`} component={Link} />
          <Tab className="TabSize" label="Product" value={`/Channel/${slug}/Product`} to={`/Channel/${slug}/Product`} component={Link} />
          <Tab className="TabSize" label="Order" value={`/Channel/${slug}/Order`} to={`/Channel/${slug}/Order`} component={Link} />
          <Tab className="TabSize" label="Settings" value={`/Channel/${slug}/Settings`} to={`/Channel/${slug}/Settings`} component={Link} />
          {/* <Tab className="TabSize" label="Gen_ApiKey" value={`/Channel/${slug}/genApikey`} to={`/Channel/${slug}/genApikey`} component={Link} /> */}

        </Tabs>
      </Box>

    </Box>
  );
};


const getComponent = (pathname, ref) => {

  switch (pathname) {
    case "Detail":
      return null;
    case "Product":
      return (
        <Box sx={{ display: "flex", width: "250px", alignItems: "center" }}>
          <Typography className="Active">Active on Channel</Typography>
          <IOSSwitch className="statusbtn" sx={{ m: 1 }} defaultChecked />
        </Box>
      );

    default:
      return;
  }

};


function Select1() {
  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <Box sx={{ width: "162px", height: "34px", border: "1px solid #858C94", borderRadius: "8px" }}>
      <FormControl fullWidth>
        <InputLabel sx={{
          "font-family": "Circe",
          "font-size": "14px",
          "font-weight": 400,
          top: "-6px"
        }}>Age</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          label="Sort"
          onChange={handleChange}
          sx={{ width: "162px", height: "34px" }}
        >
          <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
        </Select>
      </FormControl>
    </Box >
  );
}

export default function CustomizedInputBase() {
  return (
    <Paper
      component="form"
      sx={{
        p: '2px 4px', display: 'flex', alignItems: 'center', width: 228, height: "34px", border: "1px solid #858C94", "box-sizing": "border-box", borderRadius: "8px"
      }}
      elevation={0}
    >
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Search..."
        inputProps={{ 'aria-label': 'search google maps' }}
        className="plh-text"
      />


    </Paper >
  );
}